import { guideSteps } from "@/mocks/anime";

export default function GuideSection() {
  return (
    <section id="guide" className="w-full bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
          <div className="lg:col-span-1">
            <span className="inline-flex items-center gap-1.5 text-xs font-medium text-secondary-600">
              <i className="ri-book-open-line" />
              追番指南
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
              五步建立你的追番节奏
            </h2>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
              追番不必全凭感觉。掌握下面这几条经验，能明显减少「跟风点开、看两话弃番」的浪费，
              把时间留给真正对味的作品。
            </p>
            <div className="mt-6 p-5 rounded-lg bg-background-100 border border-background-200">
              <p className="text-xs font-medium text-foreground-500 mb-2">一句话总结</p>
              <p className="text-sm text-foreground-700 leading-relaxed">
                先定题材、再看三话、分清更新状态、认识术语、最后列清单。
                把选择交给自己的口味，而不是热搜。
              </p>
            </div>
          </div>

          <div className="lg:col-span-2">
            <ol className="flex flex-col">
              {guideSteps.map((item, idx) => (
                <li
                  key={item.step}
                  className={`flex gap-4 md:gap-6 py-5 ${
                    idx !== guideSteps.length - 1 ? "border-b border-background-200" : ""
                  }`}
                >
                  <span className="shrink-0 w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-accent-500 text-background-50 dark:text-foreground-950 font-heading text-base md:text-lg font-semibold">
                    {item.step}
                  </span>
                  <div className="pt-1">
                    <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">
                      {item.title}
                    </h3>
                    <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}